module.exports = __webpack_public_path__ + "img/solve1.466e3c2b.png";